import React from 'react'

export const Spinner = () => {
    return (
        <div className="container"><div className="spinner"></div></div>
    )
}
